
const key = "bf75272a-5ce2-4307-904c-e4c649fca85c";
export async function sendSubcription(mail) {
    try {
        const res = await fetch(
            'https://api.staticforms.xyz/submit',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    accessKey: key,
                    subject: 'eradevelop new subscriber',
                    honeypot: '',
                    email: mail,
                }),
            }
        )
        if (res.ok) {
            return {
                status: 200,
                body: JSON.stringify({
                    message: 'email sent!',
                }),
            }
        }
        if (res.status !== 200) {
            return {
                status: 400,
                body: JSON.stringify({
                    message: 'bad request',
                }),
            }
        }
    } catch (error) {
        console.log(error)
        return {
            status: 500,
            body: JSON.stringify({
                message: 'something went wrong with the email submit!',
            }),
        }

    }
}


